// extracted by mini-css-extract-plugin
module.exports = {"rtModeButton":"ModeButton_rtModeButton__3jJ9c","price":"ModeButton_price__16-4M","priceImg":"ModeButton_priceImg__1jgdW","priceText":"ModeButton_priceText__35yO9"};